import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateNameLookupComponent } from './template-name-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TemplateNameLookupComponent],
  exports: [TemplateNameLookupComponent]
})
export class TemplateNameLookupModule { }
